// 바코드 칸이 비었거나 설명문인 행도 인보이스(箱单发票)에는 들어간다 — 申报 대상이다(YZY 2026-10-09, 바코드 없는 샘플·파츠).
// 파서(parseWarehouseList)는 이런 행을 rows 에 넣지 않고 issues 로만 보낸다. 입고·출고 매칭이 바코드로 일하기 때문에
// 파서의 rows 는 바꾸지 않고, 인보이스 쪽에서만 이 행들을 rows 에 더해 쓴다.
// 반환: 파서 결과 + { rows: 원래 rows 에 바코드 사유 행을 더한 것(파일 순서, 더한 행엔 바코드없음:true), 바코드없는행: {행수, 수량} }
const BARCODE_REASON = /^바코드가 아닙니다/

export function withBarcodeRows(parsed) {
  if (!parsed || !Array.isArray(parsed.rows)) return parsed
  const extra = (parsed.issues || [])
    .filter(i => i && i.row && BARCODE_REASON.test(i.reason || ''))
    .map(i => i.row)
    // 업체·수량·박스번호가 정상인 행만 — 이 셋이 없으면 인보이스에 넣을 수 없다(다른 사유로도 걸린 행은 그대로 제외)
    .filter(r => r.companyid && r.수량종류 !== 'unknown' && r.박스번호)
    .map(r => Object.assign({}, r, { 바코드없음: true }))
  const sum = list => list.reduce((s, r) => s + (r.수량종류 === 'qty' ? r.수량 || 0 : 0), 0)
  const rows = parsed.rows.concat(extra).sort((a, b) => a.line - b.line)
  return Object.assign({}, parsed, {
    rows,
    바코드없는행: { 행수: extra.length, 수량: sum(extra) }
  })
}

// 화면 경고 — 고른 托盘 안에 바코드 없는 행이 있으면 알리고, 목록 수량과 인보이스 수량이 다르면 한 줄 더(조용히 틀리지 않게).
// model = buildInvoiceModel 결과, ids = 고른 托盘号
export function barcodeRowsWarnings(parsed, model, ids) {
  const w = []
  if (!parsed || !model || !Array.isArray(parsed.rows)) return w
  const pick = parsed.rows.filter(r => (ids || []).includes(r.파렛트번호))
  const qtyOf = list => list.reduce((s, r) => s + (r.수량종류 === 'qty' ? r.수량 || 0 : 0), 0)
  const nb = pick.filter(r => r.바코드없음)
  if (nb.length) w.push('바코드 없는 ' + nb.length + '행(수량 ' + qtyOf(nb) + ') 포함')
  const listQty = qtyOf(pick)
  const invQty = model.pallets.reduce((s, p) => s + p.items.reduce((t, it) => t + it.qty, 0), 0)
  if (listQty !== invQty) w.push('목록 합계(' + listQty + ')와 인보이스 합계(' + invQty + ')가 다릅니다 — 수량이 빠진 행이 있는지 확인하세요')
  return w
}
